import { apiPath } from "../../constants";
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const QUALIFICATION_REQUEST = 'FETCH_QUALIFICATION_REQUEST';
export const QUALIFICATION_FAILURE = 'FETCH_QUALIFICATION_FAILURE';
export const QUALIFICATION_SUCCESS = 'FETCH_QUALIFICATION_SUCCESS';

export const fetchQualifications = () => {
    return function(dispatch) {
        dispatch(fetchQualificationsRequest());
        return axios(apiRequestOptions(apiPath.QUALIFICATIONS.LIST))
            .then(transformHttpResponse)
            .then(response => dispatch(fetchQualificationsSuccess(response.data)))
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(fetchQualificationsFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const fetchQualificationsRequest = () => {
    return {
        type: QUALIFICATION_REQUEST,
    }
};

const fetchQualificationsFailure = (error) => {
    return {
        type: QUALIFICATION_FAILURE,
        error,
    }
};

const fetchQualificationsSuccess = (data) => {
    return {
        type: QUALIFICATION_SUCCESS,
        data,
    }
};